module.exports = __webpack_public_path__ + "images/69f1d987ffa045bd7b50828c6e8456ea-SAT.png";